import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "moebus_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const apiClient = axios.create({
    baseURL: API,
    withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

apiClient.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401 && typeof window !== "undefined") {
            const path = window.location.pathname;
            if (path.startsWith("/admin") && path !== "/admin") {
                clearToken();
                window.location.href = "/admin";
            }
        }
        return Promise.reject(err);
    }
);

export const formatApiError = (detail) => {
    if (detail == null) return "Etwas ist schiefgelaufen.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
};
